import { render, staticRenderFns } from "./editMediaPublish.vue?vue&type=template&id=f5c4f9e4&scoped=true&"
import script from "./editMediaPublish.vue?vue&type=script&lang=js&"
export * from "./editMediaPublish.vue?vue&type=script&lang=js&"
import style0 from "./editMediaPublish.vue?vue&type=style&index=0&id=f5c4f9e4&lang=less&scoped=true&"
import style1 from "./editMediaPublish.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c4f9e4",
  null
  
)

component.options.__file = "editMediaPublish.vue"
export default component.exports